import { render, staticRenderFns } from "./Coversations.vue?vue&type=template&id=592f7033&"
import script from "./Coversations.vue?vue&type=script&lang=js&"
export * from "./Coversations.vue?vue&type=script&lang=js&"
import style0 from "./Coversations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports